import AxiosCustom from "../../../common/components/apiConfig"

export function ChangePassword(new_username, new_password) {
  let config = {
    url: "update_request",
  };

  let data = {
    table: "clubmember",
    method_type: "pishro_set_password",
    data: {
      new_username: new_username,
      new_password: new_password,
    },
  };

  return AxiosCustom(config, data);
}